import type { JSX, ParentComponent } from "solid-js";
import { ErrorBoundary, Suspense } from "solid-js";
import InlineMessage from "../components/inlineMessage/InlineMessage";
import { isNil } from "lodash-es";
import { useTranslation } from "../state/i18n";
import { MoreAppError } from "../MoreAppError";
import { Icon } from "../components/icon/Icon";

export type QueryBoundaryProps = {
  errorFallback?: JSX.Element;
  loadingFallback?: JSX.Element;
};

export const QueryBoundary: ParentComponent<QueryBoundaryProps> = (props) => {
  const { t } = useTranslation();

  return (
    <ErrorBoundary
      fallback={(err) => {
        // Only handle query / api related errors
        if (!(err instanceof MoreAppError)) {
          throw err;
        }

        return isNil(props.errorFallback) ? (
          <InlineMessage variant="danger" label={t(($) => $.QUERY_BOUNDARY_ERROR_DESCRIPTION)} />
        ) : (
          props.errorFallback
        );
      }}
    >
      <Suspense fallback={isNil(props.loadingFallback) ? <LoadingIndicator /> : props.loadingFallback}>
        {props.children}
      </Suspense>
    </ErrorBoundary>
  );
};

const LoadingIndicator = () => (
  <div class="flex justify-center">
    <Icon name="spinner" size="xl" type="solid" class="animate-spin text-secondary" />
  </div>
);
